import { Components, outlinedInputClasses, Theme } from '@mui/material';
import { Border, Secondary, Disabled } from '../color';
import { CornerSmall } from '../corners';
import getTransition from '../utilities/getTransition';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: {
      ...CornerSmall,
      [`&.${outlinedInputClasses.focused}, &.${outlinedInputClasses.error}`]: {
        [`.${outlinedInputClasses.notchedOutline}`]: {
          top: -4.5,
          borderWidth: 2,
        },
      },
      [`&:not(.${outlinedInputClasses.focused}):hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: Secondary.default.hover,
      },
      [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: Disabled.default.main,
      },
    },
    notchedOutline: {
      borderColor: Border.default.main,
      borderWidth: 1,
      ...getTransition(['border-color']),
    },
  },
};
